import {faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useTranslation} from 'react-i18next'
import cssMobile from '../../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {setAttribute} from '../../../stores/editor/editor.reducer'
import RightArrowIcon from '../../icons/RightArrowIcon'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
  index: number | undefined
}

export default function MoveInsideControls({
  open,
  onBackClick,
  index,
}: ControlsProps) {
  const {t} = useTranslation()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )
  const insideImage =
    selectedImage?.type === 'masked' && index !== undefined
      ? selectedImage.inside[index]
      : undefined
  const dispatch = useAppDispatch()

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      {selectedImage?.type === 'masked' &&
      insideImage &&
      index !== undefined ? (
        <div
          className={`${cssMobile.controlItemsRow} ${cssMobile.movementInside}`}>
          <RightArrowIcon
            title={t('Mozgatás balra')}
            style={{transform: 'rotate(180deg)'}}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            position: {
                              x: item.position.x - 1,
                              y: item.position.y,
                            },
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
          <RightArrowIcon
            title={t('Mozgatás jobbra')}
            style={{transform: 'rotate(0)'}}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            position: {
                              x: item.position.x + 1,
                              y: item.position.y,
                            },
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
          <RightArrowIcon
            title={t('Mozgatás fel')}
            style={{transform: 'rotate(-90deg)'}}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            position: {
                              x: item.position.x,
                              y: item.position.y - 1,
                            },
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
          <RightArrowIcon
            title={t('Mozgatás le')}
            style={{transform: 'rotate(90deg)'}}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            position: {
                              x: item.position.x,
                              y: item.position.y + 1,
                            },
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
          <FontAwesomeIcon
            icon={faMinus}
            size="2x"
            title={t('Kicsinyítés')}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            scale: item.scale / 1.1,
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
          <FontAwesomeIcon
            icon={faPlus}
            size="2x"
            title={t('Nagyítás')}
            onClick={() => {
              dispatch(
                setAttribute({
                  id: selectedImage.id,
                  data: {
                    inside: selectedImage.inside.map((item, i) =>
                      i === index && item
                        ? {
                            ...item,
                            scale: item.scale * 1.1,
                          }
                        : item,
                    ),
                  },
                }),
              )
            }}
          />
        </div>
      ) : null}
    </ControlsBase>
  )
}
